import { twMerge } from 'tailwind-merge';

import { ParagraphProps } from '@/types';

// `html` and `text` are read off `props` rather than destructured in the
// signature. Destructuring alone would narrow fine; giving `html` a `= false`
// default is what breaks it, by severing the discriminant from `text`.
//
// What the union buys is narrower than "no untrusted value can reach the sink"
// — it cannot tell a trusted string from an untrusted one. It makes the escaped
// path the default and forces `html` to be a deliberate, string-only opt-in at
// each call site.
const Paragraph: React.FC<ParagraphProps> = (props): JSX.Element => {
  const { color = 'text-black', style = '', tag = 'p' } = props;
  const styles = `text-base mb-4 last:mb-0`;
  const mergedStyles = twMerge(styles, color, style);
  const Tag = tag;
  return (
    <>
      {props.html ? (
        // `html` is an injection sink: `text` is written to the DOM unescaped.
        // Only pass it for trusted markup (the WordPress content path). Anything
        // carrying user-, scraper-, or error-derived text must render as text.
        <Tag
          className={mergedStyles}
          dangerouslySetInnerHTML={{ __html: props.text }}
        />
      ) : (
        <Tag className={mergedStyles}>{props.text}</Tag>
      )}
    </>
  );
};

export default Paragraph;
